module.exports = __webpack_public_path__ + "img/icon-rotation.4c54c6c7.svg";